import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { isEmpty, map, size } from "lodash";
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import editIcon from "../../assets/images/icons/edit2.png";
import deleteIcon from "../../assets/images/icons/bin.png";
import {postImpDestination, getImpDestination, updateImpDestination, deleteImpDestination } from "../../store/prefrences/actions"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { Link } from "react-router-dom"

import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    OffcanvasHeader,
  OffcanvasBody,
 
  Nav,
  NavItem,
  CardI,
  CardImg,
  Offcanvas
} from "reactstrap"
import DeleteModal from "components/Common/DeleteModal";



class impDates extends Component {
    constructor(props) {
        super(props)
        this.state = {
          impdestination: {},
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleDeleteModal = () => {
      this.setState(prevState => ({
        deleteModal: !prevState.deleteModal,
      }));
    };
    onClickDelete = (impdestination) => {
      this.setState({ impdestination: impdestination });
      this.setState({ deleteModal: true });
    };
  
    handleDelete = () => {
      const { onDelete } = this.props;
      const { impdestination } = this.state;
     
      if (impdestination.id !== undefined) {
        onDelete(impdestination);
        this.setState({ deleteModal: false });
      }
    };
    handleValidSubmit(value){
      //console.log(value)
      this.props.postImpDestination(value, this.props.history);
  
    }
    componentDidMount() {
      const { onGetImpDestination } = this.props;
      onGetImpDestination(localStorage.getItem('agentId'), localStorage.getItem('userId'));
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        
      
        
        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue(`destinationAddress`, place.formatted_address);
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);
      })
      .catch(error => console.error('Error', error));
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
   componentDidUpdate(prevProps) {
      const { impdestinations } = this.props;   
     
      if (!isEmpty(impdestinations) && size(prevProps.impdestinations) !== size(impdestinations)) {
        this.setState({ impdestination: {}, isEdit: false }); 
      }
    }
  toggleRightCanvas() {
    this.setState({ impdestination: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const impdestination = arg;
    this.setState({
      impdestination: {
        id: impdestination.id,
        clientBuyerImportantDestinationId: impdestination.clientBuyerImportantDestinationId,
        clientId: impdestination.clientId,
        agentId:impdestination.agentId,
        destinationTitle:impdestination.destinationTitle,
        destinationAddress:impdestination.destinationAddress,
        destinationAddressId:impdestination.destinationAddressId,
        isValid: impdestination.isValid,
        isActive:impdestination.isActive
      },
      isEdit: true,
    });
    this.toggle();
  };
  handleGoBack = (e) => {
    e.preventDefault();
    console.log("Go Back Triggered");
    const { history } = this.props;
    if (history.length !== "POP" ) {
      history.goBack();
    } else {
      history.push("/project"); 
    }
  };
    render() {
      const { impdestinations, onUpdateImpDestination } = this.props;
      const { impdestination, isEdit, deleteModal } = this.state;
        return (
            <React.Fragment>
          
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDelete}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
               
        
       
           
                <Row>
                
                    <Col sm="12">
                      <Card className="rs-card-bg"> 
                        <CardBody className="text-rs">
                          <h5 className="card-title text-uppercase client-main-card-title">Set your important destinations</h5>
                          <p style={{fontSize:16}}>
                          Add places that matter to you - like your office, school, gym or anywhere else you visit often.
                          </p>
                          <p style={{fontSize:16}}>
                              The system will use these to calculate distance from each property you view, helping you compare locations and find the most convenient fit.
                          </p>
                          
                          <Formik
                  enableReinitialize={true}
                  initialValues={{
                    clientId: parseInt(localStorage.getItem('userId')),
                    agentId: parseInt(localStorage.getItem('agentId')),
                    destinationTitle: (this.state && this.state.destinationTitle) || "",
                    destinationAddress: (this.state && this.state.destinationAddress) || "",
                    fullAddress:'',
                    addressLine1:'',
                    addressLine2:'',
                    city:'',
                    province:'',
                    postal:'',
                    country:'',
                    longitude:'',
                    latitude:'',
                    isValid: true,
                    isActive: true,

                  }}
                  validationSchema={Yup.object().shape({
                    destinationTitle: Yup.string().required("This is Required"),
                    destinationAddress: Yup.string().required("This is Required"),
                    
                  })}

                  onSubmit={this.handleValidSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                   <Row>
                        <Col sm="4">
                        <FormGroup className="mb-3">
                            <Label htmlFor="destinationTitle">
                              {this.props.t("Title")}
                            </Label>
                            <Field
                              name="destinationTitle"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.destinationTitle && touched.destinationTitle
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="destinationTitle"
                            />
                                <ErrorMessage
                                  name="destinationTitle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="destinationAddress">
                              {this.props.t("Address")}
                            </Label>
                            <PlacesAutocomplete
                             value={values.destinationAddress}
                              onChange={(value) => setFieldValue(`destinationAddress`, value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: 'Enter Address...',
                                      className: 'form-control',
                                     
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}

                                    {suggestions.map((suggestion, i) => {
                                      const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                      const style = suggestion.active
                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                      return (
                                        <div
                                        key={i}
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                                <ErrorMessage
                                  name="destinationAddress"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>
                       
                       <Col sm="2">  <div className="clearfix"><button style={{ marginTop: 27}} type="submit" className="btn btn-primary w-md">Add</button></div></Col>



                       <h5 className="card-title">Important Destinations History</h5>
					 <div className="table-responsive">
						  <table className="table mb-0 table">
							<thead>
							  <tr>
								
								<th>Title</th>
								<th>Address</th>
								<th>Edit | Remove</th>
               
                
                {/* <th>Action</th> */}
							  </tr>
							</thead>
							<tbody>
             {/* {map(impdestinations, (impdestination, appoint) => (
                  <tr key={"_app_" + appoint}>
                     <td>{impdestination.destinationTitle}</td>
                    <td>{impdestination.destinationAddress}</td>
                   
                    
                    
                    <td>
                    <UncontrolledDropdown>
                                      <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                        Action <i className="mdi mdi-chevron-down"></i>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem onClick={() => this.toggleRightCanvas(impdestination)} href="#">Edit</DropdownItem>
                                        <DropdownItem onClick={() => this.onClickDelete(impdestination)}  href="#">Delete</DropdownItem>
                                       
                                        
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                    
                    </td>
                  </tr>            
               ))} */}
            {map(impdestinations, (impdestination, appoint) => (
              <tr key={"_app_" + appoint}>
                <td>{impdestination.destinationTitle}</td>
                <td>{impdestination.destinationAddress}</td>
                <td> <img className='tab-img me-2' src={editIcon} onClick={() => this.toggleRightCanvas(impdestination)} /> <img className='tab-img' src={deleteIcon} onClick={() => this.onClickDelete(impdestination)} /></td>
               </tr>
							  ))} 
							</tbody>
						  </table>

            
						</div> 
                    </Row>
                </Form>
                  )}
                </Formik>
                        </CardBody>
                      </Card>
                    </Col>
                </Row>
                        <Offcanvas
                          isOpen={this.state.isRight}
                          direction="end"
                          toggle={this.toggleRightCanvas}
                        >
                          <OffcanvasHeader toggle={this.toggleRightCanvas}>
                            Update
                          </OffcanvasHeader>
                          <OffcanvasBody>
                               <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: impdestination.id,
                    clientBuyerImportantDestinationId: impdestination.clientStandardHomePreferenceId,
                    clientId: impdestination.clientId,
                    agentId:impdestination.agentId,
                    destinationTitle:impdestination.destinationTitle,
                    destinationAddress:impdestination.destinationAddress,
                    destinationAddressId:impdestination.destinationAddressId,
                    isValid: impdestination.isValid,
                    isActive:impdestination.isActive

                  }}
                  validationSchema={Yup.object().shape({
                    destinationTitle: Yup.string().required("This is Required"),
                    destinationAddress: Yup.string().required("This is Required"),
                    
                  })}

                  onSubmit={values => {

                    if (isEdit) {
                      const updateData = {
                        id: values.id,
                        clientBuyerImportantDestinationId: values.clientBuyerImportantDestinationId,
                        clientId: values.clientId,
                        agentId:values.agentId,
                        destinationTitle:values.destinationTitle,
                        destinationAddress:values.destinationAddress,
                        destinationAddressId:values.destinationAddressId,
                        isValid: values.isValid,
                        isActive:values.isActive
                      };
                      onUpdateImpDestination(updateData);
                    } else {
  
                    }
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                   <Row>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="destinationTitle">
                              {this.props.t("Title")}
                            </Label>
                            <Field
                              name="destinationTitle"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.destinationTitle && touched.destinationTitle
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="destinationTitle"
                            />
                                <ErrorMessage
                                  name="destinationTitle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="destinationAddress">
                              {this.props.t("Address")}
                            </Label>
                            <PlacesAutocomplete
                             value={values.destinationAddress}
                              onChange={(value) => setFieldValue(`destinationAddress`, value)}
                              onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: 'Enter Address...',
                                      className: 'form-control',
                                     
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}

                                    {suggestions.map((suggestion, i) => {
                                      const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                      const style = suggestion.active
                                        ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                        : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                      return (
                                        <div
                                        key={i}
                                          {...getSuggestionItemProps(suggestion, {
                                            style,
                                          })}
                                        >
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>

                                <ErrorMessage
                                  name="destinationAddress"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>
                       
                       <Col sm="12">  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Update</button></div></Col>
                    </Row>
                </Form>
                  )}
                </Formik>

                          </OffcanvasBody>
                          </Offcanvas>
          
            </React.Fragment>
        )
    }
}
impDates.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    postImpDestination:PropTypes.func,
    loading:PropTypes.object,
    onGetImpDestination:PropTypes.func,
    impdestinations:PropTypes.array,
    onUpdateImpDestination:PropTypes.func,
    onDelete:PropTypes.func


}

const mapStateToProps = ({ Prefrences }) => (
    {
      impdestinations:Prefrences.impdestinations,
      loading: Prefrences.loading
    })

const mapDispatchToProps = dispatch => ({
  postImpDestination: (data) => dispatch(postImpDestination(data)),
  onGetImpDestination: (clientId, agentId) => dispatch(getImpDestination(clientId, agentId)),
  onUpdateImpDestination: (data) => dispatch(updateImpDestination(data)),
  onDelete: (data) => dispatch(deleteImpDestination(data))

});


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(impDates))